import { objectProtoToString } from './native.js';

function getTag(value) {
    return objectProtoToString.call(value);
}

export { getTag as default };
